import React, { useState } from 'react'
import propTypes from 'prop-types'

import { Button } from "@UILibrary/Button"
import { Modal, ModalHeader, ModalSubHeader, ModalContent } from '@components/Modal'

import { track } from '@utils/tracking'

import styles from "./learn-more.module.sass"

export const LearnMore = ({ heading, subHeading, children, buttonText }) => {
  const [modalOpen, setModalOpen] = useState(false)

  track('Organization Report: Learn more', { heading: heading })

  return (
    <div className='learnMore'>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      >
        <ModalHeader>{heading}</ModalHeader>
        <ModalSubHeader>{subHeading}</ModalSubHeader>

        <ModalContent>
          <div className={styles.content}>
            {children}
          </div>
          <div className={styles.actions}>
            <Button variant="primary" onClick={() => setModalOpen(false)}>Close</Button>
          </div>
        </ModalContent>
      </Modal>

      <Button
        className={styles.button}
        onClick={() => setModalOpen(true)}
      >
        {buttonText}
      </Button>
    </div>
  )
}

LearnMore.propTypes = {
  heading: propTypes.string.isRequired,
  subHeading: propTypes.string.isRequired,
  children: propTypes.node,
}
